import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default (reducers) => {
  const persistedReducer = persistReducer(
    {
      key: 'minha-key',
      storage,
      whitelist: ['autenticacao', 'notificacao'],
    },
    reducers
  );

  return persistedReducer;
};
